import React from 'react';

type SelectableChipProps = {
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

export const SelectableChip: React.FC<SelectableChipProps> = ({
  active,
  onClick,
  disabled,
  className,
  children,
}) => {
  const classes = [
    'inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors',
    active
      ? 'border-brand-primary bg-brand-primary text-white'
      : 'border-transparent bg-muted text-foreground',
    disabled ? 'opacity-50 cursor-not-allowed' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {children}
    </button>
  );
};
